import React from 'react'
import styles from "./CSS/Results.module.css"

function Results(props) {
 const { title, poster, description, actor1, actor1Character, actor2, actor2Character } = props
 
 let style = {paddingBottom : "0"}
    if (props.final){
        style.paddingBottom = "100px"
    //    style.backgroundColor = "blue"
    }
 
    return (
        <div className="results" id={props.id} style={style}>
            <div className={styles.grid_container}>
                <div className={styles.col}>
                    <img className={styles.poster} src={`https://image.tmdb.org/t/p/original/${poster}`} alt={title}/>
                </div>
                <div className={styles.col}>
                    <h1 className={styles.title}> {title} </h1>
                    <div>
                        <p>{actor1} : {actor1Character}</p>
                        <p>{actor2} : {actor2Character}</p>
                    </div>
                    <p className={styles.description}> {description} </p>
                </div>
            </div>
       
        </div>
        
    )
}

export default Results